export var Movements;
(function (Movements) {
    Movements["Trending"] = "trending";
})(Movements || (Movements = {}));
